import Component, { PolygonListingsMapProps } from './index';
import { MapProps } from '../BlockMapper';

const _map = (block: any) => {
  let data = MapProps(block);
  const props: PolygonListingsMapProps = { ...data };
  return <Component {...props} />;
};

export default _map;
